export default __webpack_public_path__ + "static/media/processing.fc3cd066.png";